import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * **Debounced validate**: each keystroke clears/resets a timer (`400ms`); when it fires, show “Checking…” then a fake
 * delayed result (`700ms`). Real apps would `fetch` and cancel in-flight requests; this teaches the UX pattern only.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'validation-email-flow',
  category: 'forms-flow',
  title: 'Email validation flow',
  description: 'Idle → debounced validating spinner → success or error (fake API).',
  tags: [T.form, T.validation, T.async],
  html: `<h2>Check email</h2>

<label class="lbl">Email
  <input type="email" id="em" autocomplete="off" placeholder="you@example.com" />
</label>

<!-- role=status: polite live region for validation message changes -->
<div id="msg" class="msg" role="status"></div>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 0.75rem;
}

.lbl {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  max-width: 18rem;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--nogrok-preview-on-surface-variant);
}

input {
  font: inherit;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid var(--nogrok-preview-outline);
  background: var(--nogrok-preview-surface-container);
  color: var(--nogrok-preview-on-surface);
}

.msg {
  margin-top: 0.75rem;
  font-size: 0.85rem;
  min-height: 1.4em;
}

.msg.ok {
  color: #7dffb0;
}

.msg.err {
  color: #ff8a8a;
}

.msg.wait {
  color: #ffcb8d;
}`,
  js: `const inp = document.getElementById('em')
const msg = document.getElementById('msg')
let t = -1

inp?.addEventListener('input', () => {
  window.clearTimeout(t)
  if (msg) {
    msg.className = 'msg'
    msg.textContent = ''
  }
  // Wait until typing pauses before doing "async" work
  t = window.setTimeout(() => {
    const v = inp instanceof HTMLInputElement ? inp.value.trim() : ''
    if (!v) return
    if (msg) {
      msg.className = 'msg wait'
      msg.textContent = 'Checking…'
    }
    window.setTimeout(() => {
      const ok = v.includes('@') && !v.startsWith('@')
      if (msg) {
        msg.className = ok ? 'msg ok' : 'msg err'
        msg.textContent = ok ? 'Available (demo).' : 'Invalid (demo).'
      }
    }, 700)
  }, 400)
})`,
}

export default preset
